import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { IApiResult } from "../interfaces/api-result.interface";
import {
  BannerMessageDetails,
  BannerMessageLocation,
  BannerMessageTargetApplication,
} from "../models/banner-message-details.model";
import { BannerMessageHidden } from "../models/banner-message-hidden.model";
import { AppConfigService } from "./app-config.service";

const LocalStorageName: string = "hiddenBannerMessages";
@Injectable({
  providedIn: "root",
})
export class BannerMessageService {
  public hiddenMessages: Array<BannerMessageHidden> = [];

  constructor(private httpClient: HttpClient, private env: AppConfigService) { }

  public getMessages(
    location: BannerMessageLocation,
    targetApplication: BannerMessageTargetApplication = null
  ): Observable<Array<BannerMessageDetails>> {
    //Load hidden messages from local storage
    this.hiddenMessages = JSON.parse(localStorage.getItem(LocalStorageName));
    if (this.hiddenMessages === null) {
      this.hiddenMessages = new Array<BannerMessageHidden>();
    }

    //If target application is specified then use in URL
    let url: string = targetApplication
      ? `${this.env.config.gatewayUrl}/BannerMessage/${location}/${targetApplication}`
      : `${this.env.config.gatewayUrl}/BannerMessage/${location}/`;

    //Get messages from API for the specified location, and then filter out hidden messages
    return this.httpClient
      .get<IApiResult<Array<BannerMessageDetails>>>(url)
      .pipe(map((data) => {

        let messages: Array<BannerMessageDetails> = data.value;

        //Hide any previously hidden messages
        let currentDate: Date = new Date();
        let unHiddenMessages: Array<number> = [];
        this.hiddenMessages.forEach((hiddenMsg) => {
          let msg: BannerMessageDetails = messages.find(
            (msg) => msg.bannerAuto === hiddenMsg.bannerAuto
          );
          if (msg) {
            if (!msg.hideable) {
              //The hideable state of this banner has changed since it was hidden, so make sure it is shown
              msg.hidden = false;
              unHiddenMessages.push(msg.bannerAuto); //ensure it is removed from the local storage.
            } else if (msg.hiddenPeriod === -1) {
              msg.hidden = true; //-1 is Hide indefinitely
            } else {
              //check if the hidden period has expired and if it hasn't, mark as hidden
              // millsecons => seconds => minutes => hours => days
              let dateDiff =
                (currentDate.getTime() -
                  new Date(hiddenMsg.hiddenDate).getTime()) /
                1000 /
                60 /
                60 /
                24;
              msg.hidden = dateDiff < msg.hiddenPeriod;
              if (!msg.hidden) {
                unHiddenMessages.push(msg.bannerAuto);
              }
            }
          }
        });

        //Update and write hidden messages back to local storage
        this.hiddenMessages = this.hiddenMessages.filter(
          (msg) => !unHiddenMessages.includes(msg.bannerAuto)
        );
        localStorage.setItem(
          LocalStorageName,
          JSON.stringify(this.hiddenMessages)
        );
        return messages;
      })
      );
  }

  public hideMessage(msg: BannerMessageDetails) {
    this.hiddenMessages.push(new BannerMessageHidden(msg));
    localStorage.setItem(LocalStorageName, JSON.stringify(this.hiddenMessages));
  }
}
